<template>
  <Layout style="height: 100%" class="main">
    <Sider
      hide-trigger
      collapsible
      :width="256"
      :collapsed-width="64"
      v-model="collapsed"
      class="left-sider"
      :style="{ overflow: 'hidden' }"
    >
      <side-menu
        accordion
        ref="sideMenu"
        :active-name="$route.path"
        :collapsed="collapsed"
        @on-select="turnToPage"
        :menu-list="menuList"
      >
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div
          class="logo-con"
          :class="{ collapsed: collapsed }"
          :style="{ width: collapsed ? '64px' : '256px' }"
        >
          <img v-show="!collapsed" :src="maxLogo" key="max-logo" />
          <img v-show="collapsed" :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar
          :collapsed="collapsed"
          @on-coll-change="handleCollapsedChange"
        >
          <user :user-avator="userAvator" />
          <!-- <language @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local"/> -->
          <fullscreen v-model="isFullscreen" style="margin-right: 10px;" />
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav
              :value="$route"
              @input="handleClick"
              :list="tagNavList"
              @on-close="handleCloseTag"
            />
          </div>
          <Content class="content-wrapper" id="main-content-con">
            <transition name="fade-transform" mode="out-in">
              <router-view />
            </transition>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import SideMenu from "./components/side-menu";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import Fullscreen from "./components/fullscreen";
import Language from "./components/language";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { getNewTagList, getNextRoute, routeEqual } from "@/libs/util";
import minLogo from "@/assets/images/logo-min.svg";
import maxLogo from "@/assets/images/logo.svg";
import types from "@/store/types";
import "./main.less";
export default {
  name: "Main",
  components: {
    SideMenu,
    HeaderBar,
    Language,
    TagsNav,
    Fullscreen,
    User
  },
  data() {
    return {
      collapsed: false,
      minLogo,
      maxLogo,
      isFullscreen: false,
      timer: null
    };
  },
  computed: {
    ...mapGetters(["userInfo", "menus", "module"]),
    menuList() {
      if (this.module) {
        if (this.menus instanceof Array) return this.menus;
        if (this.menus[this.module.key]) return this.menus[this.module.key];
      }
      return [];
    },
    tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    // tagRouter () {
    //   return this.$store.state.app.tagRouter
    // },
    userAvator() {
      return require("@/assets/images/avatar.png");
    },
    // menuList () {
    //   // return this.userInfo[this.$config.router.menusKey]
    //   return this.menuList
    // },
    local() {
      return this.$store.state.app.local;
    }
  },
  methods: {
    ...mapMutations(["setBreadCrumb", "setTagNavList", "addTag", "setLocal"]),
    ...mapActions(["handleLogin"]),
    turnToPage(route) {
      // TODO 跳转外链
      let name = route;
      let path = route;
      if (typeof route === "object") {
        name = route.name;
        path = route.path;
      } else {
        name = route;
        path = route;
      }
      if (name && name.indexOf("isTurnByHref_") > -1) {
        window.open(route.split("_")[1]);
        return;
      }
      this.$router.push({
        path
      });
    },
    handleCollapsedChange(state) {
      this.collapsed = state;
    },
    handleCloseTag(res, type, route) {
      let openName = "";
      if (type === "all") {
        this.$router.push({ name: "home" });
        openName = "home";
      } else if (routeEqual(this.$route, route)) {
        if (type === "others") {
          openName = route.name;
        } else {
          const nextRoute = getNextRoute(this.tagNavList, route);
          this.$router.push(nextRoute);
          openName = nextRoute.name;
        }
      }
      this.setTagNavList(res);
      this.$refs.sideMenu.updateOpenName(openName);
    },
    handleClick(item) {
      this.turnToPage(item);
    }
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  watch: {
    $route(newRoute) {
      this.setBreadCrumb(newRoute.matched);
      if (newRoute.meta.hideInTabBar) return;
      if (newRoute.meta.home) return; // 首页不加入列表
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
    }
  },
  mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList();
    if (!this.tagNavList || !this.tagNavList.length) {
      this.addTag({
        route: this.$store.state.app.homeRoute
      });
    }
    this.setBreadCrumb(this.$route.matched);
    clearInterval(this.timer);
    // 每5分钟轮询一次，确定用户是否在线
    // this.timer = setInterval(() => {
    // this.$store.dispatch(types.user.GET_USER_INFO).then(user => {
    // if (!user) {
    //   this.$store.dispatch(types.user.LOGOUT).then(() => {
    //     this.$router.replace({path: '/login'})
    //     this.$notify.info({
    //       title: '提示',
    //       message: '会话已过期，请重新登录',
    //       duration: 0
    //     })
    //   }).catch(err => {
    //     console.error(500, '登出失败，服务器内部错误')
    //     // reject(createError(500, '登出失败，服务器内部错误'))
    //   })
    // }
    // }).catch(err => {
    //   console.error(err)
    // 可能是服务器连接断了
    // this.$notify.info({
    //   title: '提示',
    //   set: '会话已过期，请重新登录',
    //   duration: 0
    // })
    // this.$router.replace({path: '/login'})
    //   })
    // }, 5 * 60 * 1000) // 5 * 60 * 1000
  },
  destroyed() {
    // clearInterval(this.timer)
  }
};
</script>



// WEBPACK FOOTER //
// src/view/main/main.vue